import { SxProps } from '@mui/material';

export const modalContainerSx: SxProps = {
  position: 'absolute',
  bgcolor: 'common.white',
  outline: 'none',
  bottom: { xs: 0, lg: 'auto' },
  left: { xs: 0, lg: '50%' },
  right: { xs: 0, lg: 'auto' },
  top: { xs: 'auto', lg: '50%' },
  width: { xs: 1, lg: 430 },
  borderRadius: { xs: '24px 24px 0 0', lg: '40px' },
  transform: { xs: 'none', lg: 'translate(-50%, -50%)' },
  px: { xs: 5, lg: 10 },
  pt: { xs: 14, lg: 10 },
  pb: { xs: 6, lg: 10 },
};
